import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import AbaSobre from '../reuniaoAbas/reuniaoAbaSobre';
import AbaPauta from '../reuniaoAbas/reuniaoAbaPauta';
import AbaDoc from '../reuniaoAbas/reuniaoAbaDocumentos';
import AbaUsers from '../reuniaoAbas/reuniaoAbaConvidados';

import UseStyle from '../../useStyles';

function getSteps() {
  return ['Sobre', 'Pauta e Ata', 'Documentos', 'Convidados', 'Formulário'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return 'Informações Gerais';
    case 1:
      return 'Pauta e Ata';
    case 2:
      return 'Documentos';
    case 3:
      return 'Convidados';
    case 5:
      return 'Formulário';
    default:
      return 'Unknown step';
  }
}

const ReuniaoSteper = (props) => {

  const {
    indexAtivo = 0,
    opcoes = [],
    clickHandle,
    isEditar
  } = props;

  const classes = UseStyle();
  const steps = opcoes;

  const handleChange = (num) => {
    clickHandle(num);
  }

  return (
    <div className={classes.stepperBody}>
      <Hidden xsDown>
        <Stepper connector={<ArrowForwardIosIcon style={{ fontSize: 12, color: '#c2c4d1' }} />} activeStep={indexAtivo}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};

            if (isEditar) {
              return (
                <Step onClick={() => clickHandle(label, index)} key={label}>
                  <StepLabel completed={index !== indexAtivo}>{label}</StepLabel>
                </Step>
              );
            } else {
              return (
                <Step onClick={() => clickHandle(label, index)} key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              );
            }
          })}
        </Stepper>
      </Hidden>
      <Hidden smUp>
        <Stepper orientation="vertical" connector={<ExpandMoreIcon style={{ fontSize: 24, color: '#c2c4d1' }} />} activeStep={indexAtivo}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};

            if (isEditar) {
              return (
                <Step onClick={() => clickHandle(label, index)} key={label}>
                  <StepLabel completed={index !== indexAtivo}>{label}</StepLabel>
                </Step>
              );
            } else {
              return (
                <Step onClick={() => clickHandle(label, index)} key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              );
            }
          })}
        </Stepper>
      </Hidden>
    </div>
  );
}

export default ReuniaoSteper;
